module.exports = __webpack_public_path__ + "media/67.eb8de00e.wav";